import { render, staticRenderFns } from "./createbenefits.vue?vue&type=template&id=12f84374&"
import script from "./createbenefits.vue?vue&type=script&lang=js&"
export * from "./createbenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports